import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useMyUserId } from '../../../../../data/hooks/sessionHooks';
import { useActiveLoaders } from '../../../../../data/hooks/ui/useActiveLoaders';
import ParticipantHeader from '../../../../elements/ParticipantHeader';
import ScrollableList from '../../../../elements/ScrollableList';
import SmallSpinner from '../../../../elements/SmallSpinner/SmallSpinner';
import TopBar from '../../../../elements/TopBar/TopBar';
import TopBarEvent from '../../../../elements/TopBar/TopBarEvent';
import LoadChatMessages from '../../../../loaders/LoadChatMessages';
import Screen from '../../../Screen';
import ChatMessage from '../../common/ChatMessage';
import CreateChatMessage from '../../common/CreateChatMessage';
import stylesheet from './ChatRoom.module.scss';
import ChatRoomTopBar from './ChatRoomTopBar';
import InviteParticipantButton from '../../../../elements/InviteParticipantButton';

const filterChatLoaders = (loaderId) => loaderId.match(/chat/);

const ChatRoom = (props) => {
    const { event, messages, otherParticipant } = props,
        i18n = useI18n(),
        activeChatLoaders = useActiveLoaders({ filterChatLoaders }),
        myUserId = useMyUserId();

    const header = (
        <>
            <ChatRoomTopBar event={event} otherParticipant={otherParticipant} />
            <CreateChatMessage event={event} otherParticipant={otherParticipant} />
        </>
    );

    return (
        <Screen className={stylesheet.ChatRoom} header={header}>
            {activeChatLoaders.length ? <SmallSpinner /> : null}
            <div className={stylesheet.messages}>
                <ScrollableList savePosition={'chat-' + otherParticipant.id}>
                    {messages.map((message) => (
                        <ChatMessage message={message} key={message.id} isMine={myUserId == message.userId} />
                    ))}
                </ScrollableList>
            </div>
        </Screen>
    );
};

export default (props) => (
    <LoadChatMessages sessionId={props.chatSession?.id}>
        <ChatRoom {...props} />
    </LoadChatMessages>
);
